<template>
    <transition name="fade" v-if="(isAndroid || isIOS) && isInstalled" >
        <div v-if="!minimumTimePassed || isAppLoading" class="splash-screen">
            <div v-if="isAndroid" class="text-center top-splash-screen">
                <img src="../Images/ja-logo-black.svg" class="img-logo-center" alt="Junior Achievement">
            </div>
            <div v-if="isAndroid" class="text-center bottom-splash-screen">
                <img src="../Images/sponsored-by-intuit.svg" class="img-logo-bottom" alt="INTUIT">
            </div>
        </div>
    </transition>
</template>

<script>
    import { EventBus, SplashScreen } from '../Utils'
    import { isAndroid, isIOS } from 'mobile-device-detect';

    export default {
        name: "SplashScreen",
        data() {
            return {
                minimumSeconds: 3,
                minimumTimePassed: false,
                isAppLoading: true,
                isAndroid: isAndroid,
                isIOS: isIOS,
                isInstalled: false,
            }
        },
        created() {
            EventBus.$on(SplashScreen.EVENT_SHOW, () => {
                this.isAppLoading = true
            })
            EventBus.$on(SplashScreen.EVENT_HIDE, () => {
                this.isAppLoading = false
            })
            if (window.matchMedia('(display-mode: standalone)').matches) {
                this.isInstalled = true
            }
            if (!this.isInstalled && isIOS) {
              this.isInstalled = window.navigator.standalone === true
            }
            setTimeout(() => {
                this.minimumTimePassed = true
            }, isIOS ? 500 : this.minimumSeconds * 1000)
        }
    }
</script>

<style scoped lang="stylus">
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"
    @import "~@/core/Styles/transitions.styl"

    .splash-screen
        position absolute
        width 100% !important
        height 100vh !important
        z-index 99999 !important
        background-color color-white

        .top-splash-screen
            position absolute
            top 50%
            margin-top -73px
            width 100%

            .img-logo-center
                min-width 130px
                width 240px
                height auto

        .bottom-splash-screen
            width 100%
            position absolute
            bottom 0
            background-color white
            min-height 73px

            .img-logo-bottom
                width 188px
                min-width 130px
                margin-top 15px
</style>
